import React from 'react';
import './TopLeftName.css';

const TopLeftName = (props) => {
  return (
    <a href="/" className="cs-top">Cory Scharf</a>
  )
}

export default TopLeftName;